const getters = {
  userInfo (state) {
    return state.userInfo
  },
  menus (state) {
    return state.menus
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/user/getters.js